import gql from "graphql-tag";

export default gql`
	mutation signIn($email: String!, $password: String!) {
		signIn(email: $email, password: $password) {
			token
			refreshToken
			customer {
				customerID
			}
		}
	}
`;

export const readAuthResult = ({ data }) => data?.signIn;
